import {LOGIN_USER, LOGIN_USER_ERROR, LOGIN_USER_SUCCESS, LOGOUT_USER, LOGOUT_USER_SUCCESS} from "./actionTypes";

export const loginUser = (user, history, target) => {
    return {
        type: LOGIN_USER,
        payload: {user, history, target}
    };
};

export const loginUserSuccess = () => {
    return {
        type: LOGIN_USER_SUCCESS,
        payload: {}
    };
};

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: {history}
    };
};

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {}
    };
};

export const loginUserError = (error) => {
    return {
        type: LOGIN_USER_ERROR,
        payload: error
    };
};
